import React from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../context/ThemeContext';

const ToggleButton = styled.button`
  position: relative;
  width: 56px;
  height: 28px;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: ${({ theme }) =>
    theme.mode === 'dark'
      ? theme.colors.primary.main
      : theme.colors.neutral[300]};
  border: none;
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.duration.base}
    ${({ theme }) => theme.transitions.easing.inOut};
  padding: 2px;

  &:hover {
    background: ${({ theme }) =>
      theme.mode === 'dark'
        ? theme.colors.primary.dark
        : theme.colors.neutral[400]};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary.main};
    outline-offset: 2px;
  }
`;

const ToggleThumb = styled.div<{ isDark: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ isDark }) => (isDark ? '30px' : '2px')};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.paper};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  transition: left ${({ theme }) => theme.transitions.duration.base}
    ${({ theme }) => theme.transitions.easing.inOut};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.span`
  font-size: 14px;
`;

export const ThemeToggle: React.FC = () => {
  const { toggleTheme, isDarkMode } = useTheme();

  return (
    <ToggleButton onClick={toggleTheme} aria-label="Toggle theme">
      <ToggleThumb isDark={isDarkMode}>
        <Icon>{isDarkMode ? '🌙' : '☀️'}</Icon>
      </ToggleThumb>
    </ToggleButton>
  );
};

export default ThemeToggle;
